import { __extends } from "tslib";
import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { ContentWithCopy } from "../../ContentWithCopy";
import { SplitButtonDropDown } from "../../SplitButtonDropDown";
import { Languages } from "../../../constants/languages";
import { ITranslations } from "../../../models/translations";
import { IAsyncState } from "../../../state/action";
import { loadCsvFile, loadDataFull, loadDataOptimized, loadSelect } from "../../../state/actions";
import { IReportBuilderState } from "../../../state/reducers";
var viewResponseModalCssClasses = {
    overlay: 'rb-modal-overlay',
    modal: 'rb-modal',
    closeButton: 'rb-close-button',
};
var ViewResponseOption;
(function (ViewResponseOption) {
    ViewResponseOption["optimizedJson"] = "optimizedJson";
    ViewResponseOption["fullJson"] = "fullJson";
    ViewResponseOption["sql"] = "sql";
    ViewResponseOption["csv"] = "csv";
})(ViewResponseOption || (ViewResponseOption = {}));
var ViewResponse = (function (_super) {
    __extends(ViewResponse, _super);
    function ViewResponse(props) {
        var _this = _super.call(this, props) || this;
        _this.getOptions = function () {
            var t = _this.props.t;
            return new Map([
                [ViewResponseOption.optimizedJson, t.viewResponseAsOptimizedDataJson],
                [ViewResponseOption.fullJson, t.viewResponseAsFullDataJson],
                [ViewResponseOption.sql, t.viewResponseAsSQL],
                [ViewResponseOption.csv, t.viewResponseAsCSV],
            ]);
        };
        _this.onSelect = function (newSelected) {
            _this.setState({
                selected: newSelected,
            });
            _this.onOpenModal();
        };
        _this.onOpenModal = function () {
            _this.setState({
                isOpen: true,
            });
        };
        _this.onCloseModal = function () {
            _this.setState({
                isOpen: false,
            });
        };
        _this.state = {
            isOpen: false,
            selected: ViewResponseOption.optimizedJson,
        };
        return _this;
    }
    ViewResponse.prototype.componentDidMount = function () {
        var _a = this.props, dataOptimized = _a.dataOptimized, request = _a.request, onLoadDataOptimized = _a.onLoadDataOptimized;
        if (request && (!dataOptimized || (!dataOptimized.data && !dataOptimized.error))) {
            onLoadDataOptimized(request);
        }
    };
    ViewResponse.prototype.componentDidUpdate = function (prevProps, prevState) {
        var selected = this.state.selected;
        var prevSelected = prevState.selected;
        var _a = this.props, dataFull = _a.dataFull, dataOptimized = _a.dataOptimized, file = _a.file, select = _a.select, request = _a.request, onLoadDataOptimized = _a.onLoadDataOptimized, onLoadDataFull = _a.onLoadDataFull, onLoadCsvFile = _a.onLoadCsvFile, onLoadSelect = _a.onLoadSelect;
        var prevRequest = prevProps.request;
        if (selected !== prevSelected || (request && prevRequest && request !== prevRequest)) {
            switch (selected) {
                case ViewResponseOption.fullJson:
                    if (!dataFull || (!dataFull.data && !dataFull.error)) {
                        onLoadDataFull(request);
                    }
                    break;
                case ViewResponseOption.optimizedJson:
                    if (!dataOptimized || (!dataOptimized.data && !dataOptimized.error)) {
                        onLoadDataOptimized(request);
                    }
                    break;
                case ViewResponseOption.csv:
                    if (!file || (!file.data && !file.error)) {
                        onLoadCsvFile(request);
                    }
                    break;
                case ViewResponseOption.sql:
                    if (!select || (!select.data && !select.error)) {
                        onLoadSelect(request);
                    }
                    break;
                default:
            }
        }
    };
    ViewResponse.prototype.render = function () {
        return (React.createElement("div", { className: 'rb-view-response-dropdown-container' },
            React.createElement(SplitButtonDropDown, { id: 'rb-view-response-dropdown', value: ViewResponseOption.optimizedJson, options: this.getOptions(), onSelect: this.onSelect }),
            this.renderViewResponseModal()));
    };
    ViewResponse.prototype.renderViewResponseModal = function () {
        var _a = this.state, isOpen = _a.isOpen, selected = _a.selected;
        var _b = this.props, dataFull = _b.dataFull, dataOptimized = _b.dataOptimized, file = _b.file, select = _b.select, t = _b.t;
        var options = this.getOptions();
        var body = null;
        var title = null;
        var language = null;
        switch (selected) {
            case ViewResponseOption.fullJson:
                body = dataFull && dataFull.data;
                title = options.get(ViewResponseOption.fullJson);
                language = Languages.json;
                break;
            case ViewResponseOption.optimizedJson:
                body = dataOptimized && dataOptimized.data;
                title = options.get(ViewResponseOption.optimizedJson);
                language = Languages.json;
                break;
            case ViewResponseOption.csv:
                body = file && file.data;
                title = options.get(ViewResponseOption.csv);
                break;
            case ViewResponseOption.sql:
                body = select && select.data;
                title = options.get(ViewResponseOption.sql);
                language = Languages.sql;
                break;
            default:
        }
        if (typeof body !== 'string') {
            body = JSON.stringify(body, null, 2);
        }
        return (React.createElement(Modal, { classNames: viewResponseModalCssClasses, open: isOpen, onClose: this.onCloseModal, closeIconSize: 25, animationDuration: 300 },
            React.createElement("div", { className: 'rb-title-dark rb-title-medium' }, title),
            React.createElement(ContentWithCopy, { body: body, language: language, t: t })));
    };
    return ViewResponse;
}(React.PureComponent));
var connected = connect(function (state) {
    var dataFull = state.dataFull, dataOptimized = state.dataOptimized, file = state.file, select = state.select, request = state.request, translations = state.translations;
    return {
        dataFull: dataFull,
        dataOptimized: dataOptimized,
        file: file,
        select: select,
        request: request,
        t: translations,
    };
}, function (dispatch) {
    return {
        onLoadDataFull: function (request) { return dispatch(loadDataFull(request)); },
        onLoadDataOptimized: function (request) { return dispatch(loadDataOptimized(request)); },
        onLoadCsvFile: function (request) { return dispatch(loadCsvFile(request)); },
        onLoadSelect: function (request) { return dispatch(loadSelect(request)); },
    };
})(ViewResponse);
export { connected as ViewResponse };
